
import axios from "../axios";
import { KITCHEN_MANAGE_DELIVERIES } from "../ApiUrl";



// Hedaer is added just for testing to capture header getting with this API,we can also pass header with mob header extention
export const onManageDeliveriesAPI = async (payload) => {
    try {
        const response = await axios.post(KITCHEN_MANAGE_DELIVERIES, payload, {
            headers: {
                "syed": "syed"
            }
        });
        return response;

    } catch (error) {
        console.log("onManageDeliveriesAPI  catch block", error);
        return { success: false, error };
    }
};